import api from './services/api';
//import { handleCredit, handleCreditTemplate, handleLocution } from './components/video';

var helpers = {
    getQueryVariable: (variable) => {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable)
                return pair[1];
        }
        return (false);
    },
    _validateCpf: (cpf) => {
        var sum = 0,
            mod = 0;

        var cpfPattern = /^\d{11}$/;

        if (
            !cpfPattern.test(cpf) ||
            cpf == "00000000000" ||
            cpf == "11111111111" ||
            cpf == "22222222222" ||
            cpf == "33333333333" ||
            cpf == "44444444444" ||
            cpf == "55555555555" ||
            cpf == "66666666666" ||
            cpf == "77777777777" ||
            cpf == "88888888888" ||
            cpf == "99999999999"
        ) {
            return false;
        }

        for (var i = 1; i <= 9; i++) {
            sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }

        mod = (sum * 10) % 11;

        if (mod == 10 || mod == 11) {
            mod = 0;
        }

        if (mod != parseInt(cpf.substring(9, 10))) {
            return false;
        }

        sum = 0;
        for (var x = 1; x <= 10; x++) {
            sum = sum + parseInt(cpf.substring(x - 1, x)) * (12 - x);
        }

        mod = (sum * 10) % 11;

        if (mod == 10 || mod == 11) {
            mod = 0;
        }

        if (mod != parseInt(cpf.substring(10, 11))) {
            return false;
        }

        return true;
    },
    validateDate: (fieldValue) => {
        if (fieldValue === "") {
            return false;
        } else {
            var parts = fieldValue.split("/");
            if (parts.length != 3 ||
                (parts[0] <= 0 || parts[0] > 31) ||
                (parts[1] <= 0 || parts[1] > 12) ||
                (parts[2] <= 0 || parts[2] > 9999))
                return false;

            var day = parseInt(parts[0], 10);
            var month = parseInt(parts[1], 10);
            var year = parseInt(parts[2], 10);

            var today = new Date();
            var maxYear = today.getFullYear() - 18;

            if (year < 1900 || year > maxYear || month == 0 || month > 12)
                return false;

            var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

            if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
                monthLength[1] = 29;

            return day > 0 && day <= monthLength[month - 1];
        }
    },
    validateCpf: (value, callBack) => {
        let newVal = value.replace(".","").replace(".","").replace("-","").replace(/_/g, '');
        if (newVal.length === 11) {
            if (helpers._validateCpf(newVal)) {
                callBack("");
                return value;
            }
            else {
                callBack("error");
                return "";
            }
        }
        callBack("error");
        return value;
    },
    validateDataNascimento: (value, callBack) => {
        let newVal = value.replace(/_/g, '').replace(/\//g, '');
        if (newVal.length === 8) {
            if (helpers.validateDate(value)) {
                callBack("");
                return value;
            } else {
                callBack("error");
                return "";
            }
        }
        callBack("error");
        return value;
    },
    doLogin: async (cpf, dtNasc, handleConfirm, handleUrl, handleCredit, handleCreditTemplate, handleLocution,handleModalErro, handleModalVideoUnavailable, setShowLoader) => {

        setShowLoader(true);

        let dtArr = dtNasc.split('/');
        let apiDtNasc = `${dtArr[2]}-${dtArr[1]}-${dtArr[0]}`;
        let apiCpf = cpf.replace(".","").replace(".","").replace("-","");
        let apiUserUrlParameter = helpers.getQueryVariable('N');
        let body = {
            coId: 'PB',
            userUrlParameter: apiUserUrlParameter,
            cpf: apiCpf,
            birthDate: apiDtNasc
        };

        api.post(body, {})
            .then((response) => {
                handleUrl(response.data.url);
                handleCredit(response.data.credit);
                handleCreditTemplate(response.data.creditTemplate);
                handleLocution(response.data.locution);
                handleConfirm(true);
                setShowLoader(false);
            })
            .catch((ex) => {
                try {
                    if (ex.response.status == 404) {
                        handleConfirm(false);
                        handleModalVideoUnavailable(true);
                        setShowLoader(false);
                    } else {
                        handleConfirm(false);
                        handleModalErro(true);
                        setShowLoader(false);
                    }
                }catch (e){
                    handleConfirm(false);
                    handleModalErro(true);
                    setShowLoader(false);
                }
            });
    }
}

export default helpers;